<div class="side-nav-menu-container" [ngClass]="{ selected: isSelected(menu) }">
    <button mat-button class="side-nav-menu garantor-button" [name]="menu.text.toLowerCase().replace(' ', '-')" [routerLink]="menu.redirect ? ['/'].concat(menu.redirect) : undefined" (click)="menu.onClick ? menu.onClick() : undefined">
        <mat-icon class="icon" *ngIf="menu.icon">{{ menu.icon }}</mat-icon>
        <span class="text">{{ menu.text }}</span>
    </button>
    <div class="submenu-container" *ngIf="menu.submenus">
        <app-side-nav-menu [menu]="submenu" *ngFor="let submenu of menu.submenus"></app-side-nav-menu>
    </div>
</div>
